export enum OrganizationType {
  CORPORATE = 'corporate',
  ORGANIZATION = 'organization',
}

export interface OrganizationMember {
  userId: string;
  role?: string;
  joinedAt: string;
}

export interface OrganizationInfo {
  name: string;
  city?: string;
  postalCode?: string;
  streetAddress?: string;
  country?: string;
  state?: string;
  receiveNotifications?: boolean;
  website?: string;
  size?: string;
  industry?: string;
}

export interface Organization extends OrganizationInfo {
  id: string;
  onboardingId?: string;
  userId: string; // ID of the owner/creator
  type?: OrganizationType;
  logoUrl?: string;
  logoThumbnailUrl?: string;
  members?: OrganizationMember[];
  description?: string;
  location?: string;
  founded?: string;
  createdAt?: string;
  updatedAt?: string;
  deleted?: boolean;
}

export interface OrganizationProfile extends Organization {
}

export interface OrganizationsResponse {
  organizations: Organization[];
  total: number;
  page: number;
  limit: number;
}

export interface UseOrganizationsOptions {
  initialPage?: number;
  initialLimit?: number;
  staleTime?: number;
  refetchOnWindowFocus?: boolean;
  refetchOnMount?: boolean;
}

// Helper function to get the query key for organizations
export const getOrganizationsQueryKey = (
  page: number,
  limit: number,
  search: string
) => ['organizations', { page, limit, search }];
